import ddt from '@wix/da-ddt';
import { reduxKey } from './constants';
import { ChatListSubscriptionStatus } from './types';
import { ChatWindowMode } from '../ChatWindow/types';
import noop from '../../utils/noop';
import { ChatPanelTab } from '../ChatPanel/ChatPanelTabs/types';
import { createSelector } from 'reselect';
function getState(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey];
}
// Status
export const getChatServiceStatus = (state)=>getState(state).chatServiceStatus;
export const getChatServiceError = (state)=>getState(state).chatServiceError;
// Auth
export const getChatAuthToken = (state)=>getState(state).chatAuthToken;
export const getChatPageType = (state)=>getState(state).chatPageType;
export const getChatPanelOpen = (state)=>getState(state).chatPanelOpen;
export const getChatNewMessageArrived = (state)=>getState(state).newMessageArrived;
export const getShowOverlayChatList = (state)=>getState(state).showOverlayChatList || false;
export const getNewChatParticipants = (state)=>getState(state).newChatWindowParticipants;
export const isChatReduxReady = (state)=>!!state[reduxKey];
// Chat list data
export const getChatListSubscriptionStatus = (state)=>getState(state).chatListSubscriptionStatus;
export const getChatListError = (state)=>getState(state).chatListSubscriptionError;
var _getState_chatListSubscription_fetchMore;
export const getChatListFetchMore = (state)=>{
    var _getState_chatListSubscription;
    return (_getState_chatListSubscription_fetchMore = (_getState_chatListSubscription = getState(state).chatListSubscription) === null || _getState_chatListSubscription === void 0 ? void 0 : _getState_chatListSubscription.fetchMore) !== null && _getState_chatListSubscription_fetchMore !== void 0 ? _getState_chatListSubscription_fetchMore : noop;
};
export const getChatListCursor = (state)=>{
    var _getState;
    return (_getState = getState(state)) === null || _getState === void 0 ? void 0 : _getState.chatsCursor;
};
export const getChatListChats = (state)=>getState(state).chats;
export const getChatListStatus = (state)=>getState(state).chatsStatus;
export const getChatUnreadCount = (state)=>{
    var _getState_globalUnreadCount;
    return ((_getState_globalUnreadCount = getState(state).globalUnreadCount) === null || _getState_globalUnreadCount === void 0 ? void 0 : _getState_globalUnreadCount.count) || 0;
};
export const getChatListIsReady = (state)=>{
    const chatListSubscriptionStatus = getChatListSubscriptionStatus(state);
    const chatListStatus = getChatListStatus(state);
    return isChatReduxReady(state) && chatListSubscriptionStatus === ChatListSubscriptionStatus.LISTENING && (chatListStatus === null || chatListStatus === void 0 ? void 0 : chatListStatus.isFetchingRooms) === false;
};
export const isChatListUsingCache = (state)=>getState(state).chatsUsingCache;
export const getChatListActiveTab = (state)=>getState(state).chatListTab || ChatPanelTab.GENERAL;
// Chat requests
export const getChatRequestsSubscriptionStatus = (state)=>getState(state).chatRequestsSubscriptionStatus;
export const getChatRequestsSubscriptionError = (state)=>getState(state).chatRequestsSubscriptionError;
var _getState_chatRequestsSubscription_fetchMore;
export const getChatRequestsFetchMore = (state)=>{
    var _getState_chatRequestsSubscription;
    return (_getState_chatRequestsSubscription_fetchMore = (_getState_chatRequestsSubscription = getState(state).chatRequestsSubscription) === null || _getState_chatRequestsSubscription === void 0 ? void 0 : _getState_chatRequestsSubscription.fetchMore) !== null && _getState_chatRequestsSubscription_fetchMore !== void 0 ? _getState_chatRequestsSubscription_fetchMore : noop;
};
export const getChatRequestsCursor = (state)=>{
    var _getState;
    return (_getState = getState(state)) === null || _getState === void 0 ? void 0 : _getState.chatRequestsCursor;
};
export const getChatRequests = (state)=>getState(state).chatRequests;
export const getChatRequestsStatus = (state)=>getState(state).chatRequestsStatus;
export const isChatRequestsUsingCache = (state)=>getState(state).chatRequestsUsingCache;
// Chatrooms
export const getOpenChatrooms = (state)=>getState(state).chatrooms;
export const getOpenChatroomsOrder = (state)=>getState(state).openChatroomsOrder;
/** Pulls a full list of participants we need to send a new chat request. This includes the DM participant's ID. */ export const getChatroomNewGroupChatParticipants = (state, chatroomId)=>{
    var _getOpenChatrooms, _getOpenChatrooms_chatroomId, _getOpenChatrooms1, _getOpenChatrooms_chatroomId1, _getOpenChatrooms_chatroomId_room;
    var _getOpenChatrooms_chatroomId_newChatParticipants;
    const participants = (_getOpenChatrooms_chatroomId_newChatParticipants = (_getOpenChatrooms = getOpenChatrooms(state)) === null || _getOpenChatrooms === void 0 ? void 0 : (_getOpenChatrooms_chatroomId = _getOpenChatrooms[chatroomId]) === null || _getOpenChatrooms_chatroomId === void 0 ? void 0 : _getOpenChatrooms_chatroomId.newChatParticipants) !== null && _getOpenChatrooms_chatroomId_newChatParticipants !== void 0 ? _getOpenChatrooms_chatroomId_newChatParticipants : [];
    const currentParticipant = (_getOpenChatrooms1 = getOpenChatrooms(state)) === null || _getOpenChatrooms1 === void 0 ? void 0 : (_getOpenChatrooms_chatroomId1 = _getOpenChatrooms1[chatroomId]) === null || _getOpenChatrooms_chatroomId1 === void 0 ? void 0 : (_getOpenChatrooms_chatroomId_room = _getOpenChatrooms_chatroomId1.room) === null || _getOpenChatrooms_chatroomId_room === void 0 ? void 0 : _getOpenChatrooms_chatroomId_room.otherParticipantId;
    if (currentParticipant) {
        participants.push({
            id: currentParticipant,
            name: ''
        });
    }
    return participants;
};
export const getIsChatroomOpen = (state, chatroomId)=>{
    const openChatroomIds = getOpenChatroomsOrder(state);
    return !!(openChatroomIds === null || openChatroomIds === void 0 ? void 0 : openChatroomIds.includes(chatroomId));
};
export const getNewChatRequests = (state)=>getState(state).newChatRequests;
export const getNewChatRequestsList = createSelector(getNewChatRequests, (items)=>Object.values(items !== null && items !== void 0 ? items : {}));
export const getPendingNewChatMessage = (state, requestId)=>{
    var _getState_newChatRequests, _getState_newChatRequests_requestId;
    return (_getState_newChatRequests = getState(state).newChatRequests) === null || _getState_newChatRequests === void 0 ? void 0 : (_getState_newChatRequests_requestId = _getState_newChatRequests[requestId]) === null || _getState_newChatRequests_requestId === void 0 ? void 0 : _getState_newChatRequests_requestId.pendingMessage;
};
const defaultChatroomValue = {};
export const getChatroom = (state, chatId)=>{
    const chatrooms = getState(state).chatrooms;
    if (chatrooms && chatrooms.hasOwnProperty(chatId)) {
        return chatrooms[chatId];
    } else {
        ddt.log('chat', `We tried to get a chatroom that wasn't inside of our store -- chatroom id [${chatId}]`);
        return defaultChatroomValue;
    }
};
/** Return a list of chatroom ids of open chat windows that are currently minimized */ export const getMinimizedChatWindows = (state)=>{
    const chatrooms = getOpenChatrooms(state) || {};
    const openChatroomsOrder = getOpenChatroomsOrder(state) || [];
    return Object.keys(chatrooms).filter((id)=>{
        const chatroom = chatrooms[id];
        // because a closed room's data persists in `chatrooms` even after it's closed,
        // we also need to check this array to see if it's been closed
        const isOpen = openChatroomsOrder.includes(id);
        return chatroom && isOpen && chatroom.mode === ChatWindowMode.MINIMIZED;
    });
};
export const getChatsWithNewMsgs = (state)=>getState(state).chatsWithNewMsgs;
export const getChatWindowFooterHeight = (state, chatId)=>{
    var _getState_footerHeights;
    return (_getState_footerHeights = getState(state).footerHeights) === null || _getState_footerHeights === void 0 ? void 0 : _getState_footerHeights[chatId];
};
var _getState_nextShouldOpenRequestIds;
export const getNextShouldOpenRequestIds = (state)=>(_getState_nextShouldOpenRequestIds = getState(state).nextShouldOpenRequestIds) !== null && _getState_nextShouldOpenRequestIds !== void 0 ? _getState_nextShouldOpenRequestIds : [];
export const getChatEnvironment = (state)=>{
    var _state_environment;
    return (_state_environment = state.environment) === null || _state_environment === void 0 ? void 0 : _state_environment.type;
};
export const getChatWorker = (state)=>getState(state).chatWorker;
export const getChatWorkerStatus = (state)=>getState(state).chatWorkerStatus;
export const getChatWorkerIdleStatus = (state)=>getState(state).chatWorkerIdleStatus;
